import { pt, type Dictionary } from "./dictionaries/pt";
import { en } from "./dictionaries/en";
import { DEFAULT_LOCALE, type Locale } from "./types";

export const DICTIONARIES: Record<Locale, Dictionary> = { pt, en };

export const getDictionaryFor = (locale: Locale): Dictionary => DICTIONARIES[locale] ?? DICTIONARIES[DEFAULT_LOCALE];

export type { Dictionary };
export * from "./types";
